import type { ResourceCategory } from '../../domain/types';

export const resourceCategories: { id: ResourceCategory; label: string }[] = [
  { id: 'image', label: 'Image' },
  { id: 'photoshop', label: 'Photoshop' },
  { id: 'vector', label: 'Vector' },
  { id: 'other', label: 'Other' },
];

export function resourceCategoryLabel(category: ResourceCategory = 'other') {
  return resourceCategories.find(item => item.id === category)?.label ?? 'Other';
}
